var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIpd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-ipd") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Specs",
    transform: "translate(-354.000000, -423.000000)",
    stroke: "#010003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-ipd",
    transform: "translate(354.000000, 423.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 9.915,
    y1: 8.036,
    x2: 0.5,
    y2: 22.5,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.085,
    y1: 8.036,
    x2: 22.5,
    y2: 22.5,
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    strokeLinecap: "square",
    cx: 11.5,
    cy: 5.5,
    r: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.5,
    y1: 0.5,
    x2: 11.5,
    y2: 2.5,
    id: "Path",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.5,
    y1: 12.5,
    x2: 11.5,
    y2: 16.5,
    id: "Path",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.5,
    y1: 14.5,
    x2: 19.5,
    y2: 14.5,
    id: "Path",
    strokeLinecap: "square"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIpd);
export default __webpack_public_path__ + "static/media/icon-ipd.3b93ba223976d83e02a0f01431c7419a.svg";
export { ForwardRef as ReactComponent };